/**
 * @class MediaExternalVideo
 * @classdesc Handles creating an external video media element
 *
 * @extends Core.Component
 */
export default class MediaExternalVideo extends Core.Component {
  constructor(el, context) {
    super(el, context);

    const videoEl = el.querySelector('iframe');

    this._video = Core.Media.createVideo(videoEl, this.data.type);
  }

  /**
   * Play the video
   * @public
   */
  play() {
    this._video.play();
  }

  /**
   * Pause the video
   * @public
   */
  pause() {
    this._video.pause();
  }
}
